<!-- src/pages/AdminDashboard.vue -->
<template>
  <section id="portfolio">
    <div class="container">
      <div class="row">
        <div
          v-for="t in tiles"
          :key="t.to"
          class="col-sm-4 portfolio-item"
        >
          <RouterLink class="portfolio-link tile" :to="t.to">
            <!-- Optional image slot:
                 If you later add images (e.g. '@/assets/img/admin/locations.png'),
                 drop an <img> here with class="img-responsive" and the CSS
                 hover caption will still work. -->
            <div class="caption">
              <div class="caption-content">
                <h3>{{ t.title }}</h3>
                <h4 v-if="t.subtitle">{{ t.subtitle }}</h4>
              </div>
            </div>

            <!-- Fallback tile surface (keeps height even without an image) -->
            <div class="tile-surface">
              <strong>{{ t.title }}</strong>
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const router = useRouter()
const auth = useAuthStore()

onMounted(() => {
  if (!auth.isAdminRole) {
    router.replace('/') // or send to /login if you prefer
  }
})

const tiles = [
  //{ title: 'Locations',     to: '/map' },
  { title: 'Search',        to: '/employee/all' },
  { title: 'Add Employee',  to: '/employee/add' },
  { title: 'User Management', to: '/admin/users' },
  //{ title: 'Org Chart',     to: '/company/all' },
  //{ title: 'Statistics',    to: '/statistics' },
  //{ title: 'Contact Us',    to: '/contacts' },
]
</script>

<style scoped>
/* Keep this minimal; your legacy CSS handles most styling. 
   We only ensure a nice, consistent tile height when no images are used. */

.tile {
  display: block;
  position: relative;
  max-width: 400px;
  margin: 0 auto;
  text-decoration: none;
}

.tile-surface {
  height: 220px;               /* gives the portfolio tile some body */
  background: #f7f7f7;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2C3E50;
}

/* Let the legacy .caption overlay show on hover (it already has transitions) */
.tile:hover .caption {
  opacity: 1;                  /* legacy CSS sets transition; this ensures effect shows even with no image */
}
</style>
